import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { BaseModule } from 'lib/modules';
import { PROCESSOR_VIEW_ROLES } from 'lib/userHelpers';

// Lazy-loaded page component
const ProcessorChatPage = lazy(() =>
  import(/* webpackChunkName: "processor-chat" */ 'pages/processor/chat').then(
    (m) => ({ default: m.default }),
  ),
);

/**
 * Chat Module Implementation
 */
class ChatModuleClass extends BaseModule {
  id = 'CHAT';
  name = 'Chat';
  label = 'Processor Chat';
  description = 'Processor-customer communication and chat interface';
  version = '1.0.0';
  /**
   * Creates route objects for the Chat module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    // Processor chat. The `:id?` optional segment means both `/processor/chat`
    // and `/processor/chat/:id` (a selected room, deep-linked or navigated to
    // from the list) render the same page — without it the detail URL matched
    // no route and fell through to a different layout / full page load.
    routes.push({
      path: '/processor/chat/:id?',
      element: (
        <RouteProtector
          component={ProcessorChatPage}
          moduleId="CHAT"
          allowedUserRoles={PROCESSOR_VIEW_ROLES}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const ChatModule = new ChatModuleClass();
